/**
 * JSR
 * _google_analytics.js
 * Skript pro webovou analytiku Google
 *
 * @package zaklad
 *
 * @author OXID
 * @copyright (c) 2007-2026 OXID
 * @version 2.5.9
 */

/**
 * Odešle data do dataLayer
 * @param {type} event
 * @param {type} ecommerce
 * @param {type} ecommerce_name
 * @param {type} value
 * @returns true
 */
function _ga_send( event, ecommerce, ecommerce_name, value )
{
  var data = {};

  data['event'] = event;

  if ( ecommerce !== null )
  {
    if ( ecommerce_name === '' || ecommerce_name === null || ecommerce_name === false ) ecommerce_name = 'ecommerce';
    data[ecommerce_name] = ecommerce;
  }

  if ( value !== null ) data['value'] = parseFloat( value );

  console.log( event )
  console.log( ecommerce );
  console.log( ecommerce_name );
  console.log( value );

  window.dataLayer = window.dataLayer || [];
  if ( ecommerce !== null && ecommerce_name === 'ecommerce' ) window.dataLayer.push( { 'ecommerce': null } );
  window.dataLayer.push( data );

  return true;
}

function _ga_value( value )
{
  return value !== undefined ? value.toString().trim() : null;
}

function _ga_number( value )
{
  return value !== undefined ? parseFloat( value.toString().replace( ',', '.' ).replace( ' ', '' ).trim() ) : null;
}

/**
 * Odešle do OpenAI (ChatGPT Ads) pixelu událost items_added
 * @param {Array} products Pole položek { id, name, price, quantity }
 * @returns {boolean} true při odeslání, false pokud pixel není načtený nebo nejsou položky
 */
function _oaiq_items_added( products )
{
  if ( !window.oaiq ) return false;

  var currency = _ga_value( $('#js_web_mena').val() );
  var amount = 0;
  var contents = [];

  $.each( products, function( i, p )
  {
    if ( p.id === null || p.id === '' ) return;

    var price = isNaN( p.price ) || p.price === null ? 0 : Math.round( p.price * 100 );
    var quantity = isNaN( p.quantity ) || p.quantity === null ? 1 : p.quantity;

    amount += price * quantity;
    contents.push({
      'id': p.id,
      'name': p.name,
      'content_type': 'product',
      'quantity': quantity,
      'amount': price,
      'currency': currency
    });
  });

  if ( contents.length === 0 ) return false;

  oaiq( 'measure', 'items_added', {
    type: 'contents',
    amount: amount,
    currency: currency,
    contents: contents
  });

  return true;
}

function ga_basket()
{
  //výpis košíku
  var data = { 'items': [] };
  $('.ga_item','#kosik').each( function( i )
  {
    var category_parts = $(this).data('category') !== undefined ? $(this).data('category').toString().trim().split('/') : [];

    var item = {
      'item_name': _ga_value( $(this).data('name') ),
      'item_id': _ga_value( $(this).data('id') ),
      'price': _ga_number( $(this).data('price') ),
      'item_brand': _ga_value( $(this).data('brand') ),
      //'item_variant': _ga_value( $(this).data('variant') ),
      'quantity': _ga_number( $(this).data('quantity') )
    };
    if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
    if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
    if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
    if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
    if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );

    data['items'].push( item );
  });

  _ga_send( 'view_cart', data, 'ecommerce', null );
  data = null;

  //tlačítka pro změnu množství položky
  $('.ga_cart_plus,.ga_cart_minus,.ga_cart_remove').click( function()
  {
    var old_amount = _ga_number( $(this).closest('tr').find('.ga_item').data('quantity') );
    var new_amount = false;
    if ( $(this).hasClass( 'ga_cart_plus' ) ) new_amount = old_amount + 1;
    else if ( $(this).hasClass( 'ga_cart_minus' ) ) new_amount = old_amount - 1;
    else if ( $(this).hasClass( 'ga_cart_remove' ) ) new_amount = 0.0;
    if ( new_amount < 0.0 ) new_amount = 0.0;

    if ( !isNaN( new_amount ) )
    {
      var ga_item = $(this).closest('tr').find('.ga_item');
      var diff = new_amount - old_amount;
      if ( ga_item.length > 0 && diff !== 0.0 )
      {
        var action = diff > 0 ? 'add' : 'remove';
        var event = diff > 0 ? 'add_to_cart' : 'remove_from_cart';
        var ga_price = _ga_number( ga_item.data('price') );
        var diff_final = diff < 0 ? diff * -1 : diff;
        var category_parts = ga_item.data('category') !== undefined ? ga_item.data('category').toString().trim().split('/') : [];

        var item = {
          'item_name': _ga_value( ga_item.data('name') ),
          'item_id': _ga_value( ga_item.data('id') ),
          'price': ga_price,
          'item_brand': _ga_value( ga_item.data('brand') ),
          //'item_variant': _ga_value( ga_item.data('variant') ),
          'quantity': diff_final
        };
        if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
        if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
        if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
        if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
        if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );

        var data2 = { 'items': [] };
        data2[action] = {
          'products': [{
            'name': _ga_value( ga_item.data('name') ),
            'id': _ga_value( ga_item.data('id') ),
            'price': ga_price,
            'brand': _ga_value( ga_item.data('brand') ),
            'category': _ga_value( ga_item.data('category') ),
            //'variant': _ga_value( ga_item.data('variant') ),
            'quantity': diff_final
          }]
        };
        data2['items'].push( item );

        _ga_send( event, data2, 'ecommerce', null );
        _ga_send( 'remarketing_' + event, [{ 'id': _ga_value( ga_item.data('id') ), 'google_business_vertical': 'retail', 'quantity': diff_final }], 'items', ga_price );
        if ( diff > 0 ) _oaiq_items_added( [{ 'id': _ga_value( ga_item.data('id') ), 'name': _ga_value( ga_item.data('name') ), 'price': ga_price, 'quantity': diff_final }] );
        data2 = null;
      }
    }
  });
}

function ga_basket_change()
{
  //zobrazení detailu produktu
  var data = { 'items': [] };
  
  var temp = $( ".ga_item" );
  
  var category_parts = $(temp).data('category') !== undefined ? $(temp).data('category').toString().trim().split('/') : [];

  var item = {
    'item_name': _ga_value( $(temp).data('name') ),
    'item_id': _ga_value( $(temp).data('id') ),
    'price': _ga_number( $(temp).data('price') ),
    'item_brand': _ga_value( $(temp).data('brand') )
    //'item_variant': _ga_value( $(this).data('variant') ),
  };
  if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
  if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
  if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
  if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
  if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );

  data['items'].push( item );

  _ga_send( 'add_to_cart', data, 'ecommerce', null );
  _oaiq_items_added( [{ 'id': item['item_id'], 'name': item['item_name'], 'price': item['price'], 'quantity': 1 }] );
}

function ga_thankyou()
{
  var item = $('#ga_container');
  if ( item.length > 0 )
  {
    var ga_value = _ga_number( item.data('value') );
    var data = {
      'currency': _ga_value( item.data('currency') ),
      'currencyCode': _ga_value( item.data('currency') ),
      'value': ga_value,
      'tax': _ga_number( item.data('tax') ),
      'shipping': _ga_number( item.data('shipping') ),
      'transaction_id': _ga_value( item.data('transid') ),
      'order_flag': _ga_value( item.data('flag') ),//vlastní označení objednávky
      'purchase': {
          'actionField': {
            'id': _ga_value( item.data('transid') ),
            'revenue': _ga_number( item.data('value') ),
            'tax': _ga_number( item.data('tax') ),
            'shipping': _ga_number( item.data('shipping') )
            },
          'products': []
        },
      'items': []
    };
    if ( item.data('coupon') !== null && item.data('coupon') !== false && item.data('coupon') !== '' )
    {
      data['coupon'] = _ga_value( item.data('coupon') );
      data['purchase']['actionField']['coupon'] = _ga_value( item.data('coupon') );
    }

    var data2 = [];
    $('.ga_item','#ga_container').each( function( i )
    {
      var category_parts = $(this).data('category') !== undefined ? $(this).data('category').toString().trim().split('/') : [];

      var item = {
        'item_name': _ga_value( $(this).data('name') ),
        'item_id': _ga_value( $(this).data('id') ),
        'price': _ga_number( $(this).data('price') ),
        'item_brand': _ga_value( $(this).data('brand') ),
        //'item_variant': _ga_value( $(this).data('variant') ),
        'quantity': _ga_number( $(this).data('quantity') )
      };
      if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
      if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
      if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
      if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
      if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );

      data['items'].push( item );
      data['purchase']['products'].push({
        'name': _ga_value( $(this).data('name') ),
        'id': _ga_value( $(this).data('id') ),
        'price': _ga_number( $(this).data('price') ),
        'brand': _ga_value( $(this).data('brand') ),
        'category': _ga_value( $(this).data('category') ),
        //'variant': _ga_value( $(this).data('variant') ),
        'quantity': _ga_number( $(this).data('quantity') )
      });
      data2.push({
        'id': _ga_value( $(this).data('id') ),
        'google_business_vertical': 'retail',
        'quantity': _ga_number( $(this).data('quantity') )
      });
    });

    _ga_send( 'purchase', data, 'ecommerce', null );
    _ga_send( 'remarketing_purchase', data2, 'items', ga_value );
    data = null;
    data2 = null;
  }
}

function ga_konfigurator()
{
  window.dataLayer = window.dataLayer || [];

  $('.ga_step').click( function()
  {
    var step = parseInt( $(this).data('ga-step') );
    window.dataLayer.push({
      'event': 'configurator_step',
      'configurator_step_number': _ga_number( step )
    });
    console.log( 'configurator_step_number: ' + step );

    if ( $(this).hasClass( 'ga_basket_all' ) )
    {
      var data2 = { 'items': [], 'add': { 'products': [] } };
      var data3 = [];
      var diff_final = _ga_number( $('.ga_basket_all_quantity').val() );
      var price_sum = 0.0;
      $(this).closest('#skladani_stolu_sekce_4').find('table.kontrola .ga_item').each( function( i )
      {
        var ga_item = $(this);
        var ga_price = _ga_number( ga_item.data('price') );
        var category_parts = ga_item.data('category') !== undefined ? ga_item.data('category').toString().trim().split('/') : [];

        var item = {
          'item_name': _ga_value( ga_item.data('name') ),
          'item_id': _ga_value( ga_item.data('id') ),
          'price': ga_price,
          'item_brand': _ga_value( ga_item.data('brand') ),
          //'item_variant': _ga_value( ga_item.data('variant') ),
          'quantity': diff_final
        };
        if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
        if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
        if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
        if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
        if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );


        var item2 = {
          'name': _ga_value( ga_item.data('name') ),
          'id': _ga_value( ga_item.data('id') ),
          'price': ga_price,
          'brand': _ga_value( ga_item.data('brand') ),
          'category': _ga_value( ga_item.data('category') ),
          //'variant': _ga_value( ga_item.data('variant') ),
          'quantity': diff_final
        };

        var item3 = {
          'id': _ga_value( ga_item.data('id') ),
          'google_business_vertical': 'retail',
          'quantity': diff_final
        };

        price_sum += ( ga_price * diff_final );

        data2['items'].push( item );
        data2['add']['products'].push( item2 );
        data3.push( item3 );
      });

      _ga_send( 'add_to_cart', data2, 'ecommerce', null );
      _ga_send( 'remarketing_add_to_cart', data3, 'items', price_sum );
      _oaiq_items_added( $.map( data2['add']['products'], function( p ) { return { 'id': p.id, 'name': p.name, 'price': p.price, 'quantity': p.quantity }; } ) );
      data2 = null;
    }
  });
}

function ga_produkt()
{
  //zobrazení detailu produktu
  var data = { 'items': [] };
  
  var temp = $( ".ga_item" );
  
  var category_parts = $(temp).data('category') !== undefined ? $(temp).data('category').toString().trim().split('/') : [];

  var item = {
    'item_name': _ga_value( $(temp).data('name') ),
    'item_id': _ga_value( $(temp).data('id') ),
    'price': _ga_number( $(temp).data('price') ),
    'item_brand': _ga_value( $(temp).data('brand') )
    //'item_variant': _ga_value( $(this).data('variant') ),
  };
  if ( category_parts[0] ) item['item_category'] = _ga_value( category_parts[0] );
  if ( category_parts[1] ) item['item_category2'] = _ga_value( category_parts[1] );
  if ( category_parts[2] ) item['item_category3'] = _ga_value( category_parts[2] );
  if ( category_parts[3] ) item['item_category4'] = _ga_value( category_parts[3] );
  if ( category_parts[4] ) item['item_category5'] = _ga_value( category_parts[4] );

  data['items'].push( item );

  _ga_send( 'view_item', data, 'ecommerce', null );
}

/**
 * Vloží retargetingový container tag ADCELL dle typu stránky (jen pokud je ADCELL povolen - existuje #js_adcell)
 * @returns {boolean} true při vložení tagu, jinak false
 */
function ga_adcell()
{
  var adcell = $('#js_adcell');
  if ( adcell.length === 0 || !adcell.data('pid') ) return false;

  var typ = _ga_value( adcell.data('typ') );
  var params = {};
  var ids = [];
  var quantities = [];
  var count = 0;
  var total = 0.0;

  switch ( typ )
  {
    case 'startpage':
      params = { 'method': 'track', 'pid': adcell.data('pid'), 'type': 'startpage' };
      break;

    case 'category':
    case 'search':
      $('#vypis_produktu_celek .ga_list_item').each( function()
      {
        var id = _ga_value( $(this).data('id') );
        if ( id ) ids.push( id );
      });

      if ( typ === 'category' ) params = { 'method': 'category', 'pid': adcell.data('pid'), 'categoryName': _ga_value( adcell.data('kat-nazev') ), 'categoryId': _ga_value( adcell.data('kat-id') ) };
      else params = { 'method': 'search', 'pid': adcell.data('pid'), 'search': new URLSearchParams( window.location.search ).get( 'hledane' ) || '' };

      params['productIds'] = ids.join( ',' );
      params['productSeparator'] = ',';
      break;

    case 'product':
      if ( !adcell.data('produkt-id') ) return false;
      params = {
        'method': 'product',
        'pid': adcell.data('pid'),
        'productId': _ga_value( adcell.data('produkt-id') ),
        'productName': _ga_value( adcell.data('produkt-nazev') ),
        'categoryId': _ga_value( adcell.data('kat-id') ),
        'productIds': _ga_value( adcell.data('produkt-id') ),
        'productSeparator': ','
      };
      break;

    case 'basket':
    case 'checkout':
      //jen produkty (doprava a platba nemají id), cena v ga_item je bez DPH
      $('.ga_item', typ === 'basket' ? '#kosik' : '#ga_container').each( function()
      {
        var id = _ga_value( $(this).data('id') );
        if ( !id ) return;

        var quantity = _ga_number( $(this).data('quantity') ) || 1;
        var price = _ga_number( $(this).data('price') ) || 0;

        ids.push( id );
        quantities.push( quantity );
        count += quantity;
        total += price * quantity;
      });

      if ( ids.length === 0 ) return false;

      params = { 'method': typ, 'pid': adcell.data('pid') };
      if ( typ === 'checkout' ) params['basketId'] = _ga_value( $('#ga_container').data('transid') );
      params['productIds'] = ids.join( ',' );
      params['productSeparator'] = ',';
      params['quantities'] = quantities.join( ',' );
      params['basketProductCount'] = count;
      params['basketTotal'] = total.toFixed( 2 );
      break;

    default:
      return false;
  }

  var script = document.createElement( 'script' );
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://t.adcell.com/js/inlineretarget.js?' + $.param( params );
  document.body.appendChild( script );

  return true;
}

function ga_all()
{
  window.dataLayer = window.dataLayer || [];

//  //id uživatele nebo anonymous
//  var ga_item = $('.ga_user');
//  var user_id = ga_item.length > 0 ? ga_item.data('userid') : '';
//
//  window.dataLayer.push({
//    'userId': _ga_value( user_id ),
//    'userType': _ga_value( user_id !== '' && user_id !== null && user_id !== false ? 'signed_in' : 'anonymous' )
//  });
//  console.log( 'ga_user_type: ' + ( user_id !== '' && user_id !== null && user_id !== false ? 'signed_in' : 'anonymous' ) );
//
//  //kliknutí na tlačítko registrace
//  $('.ga_register').click( function()
//  {
//    _ga_send( 'sign_up', null, null, null );
//  });
//
//  //kliknutí na tlačítko přihlášení
//  $('.ga_login').click( function()
//  {
//    _ga_send( 'login', null, null, null );
//  });
}

$(document).ready(function()
{
  var page = $('#ga_page').val();

  switch ( page )
  {

    case 'eshop/e_kosik.tpl':
      ga_basket();
      break;

    case 'eshop/e_thankyou.tpl':
      ga_thankyou();
      break;

    case 'eshop/e_konfigurator.tpl':
      ga_konfigurator();
      break;
      
    case 'eshop/e_produkt.tpl':
      ga_produkt();
      break;
  }

  //tlačítka vložit do košíku napříč systémem
  $( ".koupit" ).click( function(){
    ga_basket_change();
  });

  //na každé stránce
  ga_all();

  //ADCELL retargeting (jen pokud je povolen)
  ga_adcell();

});

